// 261010 UI2 (L6d) — hộp "Cắt đầu / đuôi" một clip. Điểm cắt CHỈ được ghi lại (BE `PUT /clips/:id/trim`) để dùng khi ghép ở CapCut — clip gốc KHÔNG đổi, KHÔNG tạo lại clip.
// Luật kiểm ở `workflowL6Utils.trimBodyOf` (thuần, khớp BE). Hộp này chính là bước xác nhận. Không giá.
import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Modal } from 'antd';
import { filmApi } from '../../services/api/film';
import { manualEditErrorText, trimBodyOf, trimSummaryOf } from './workflowL6Utils';

export interface TrimTarget { clipId: string; label: string; durationS: number | null; cutInS: number | null; cutOutS: number | null }
interface Props { target: TrimTarget | null; onClose: () => void; onSaved: () => void }

const ClipTrimModal: React.FC<Props> = ({ target, onClose, onSaved }) => {
  const [inS, setInS] = useState('');
  const [outS, setOutS] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    if (!target) return;
    setInS(target.cutInS != null ? String(target.cutInS).replace('.', ',') : '');
    setOutS(target.cutOutS != null ? String(target.cutOutS).replace('.', ',') : (target.durationS ? String(target.durationS).replace('.', ',') : ''));
    setErr(null); setBusy(false);
  }, [target]);
  if (!target) return null;
  const chk = trimBodyOf(inS, outS, target.durationS);
  const dur = target.durationS;
  const save = async (body: { cutInS: number | null; cutOutS: number | null }) => {
    setBusy(true); setErr(null);
    try { await filmApi.trimClip(target.clipId, body.cutInS, body.cutOutS); onSaved(); onClose(); }
    catch (e) { setErr(manualEditErrorText(e, 'Cắt clip')); }
    finally { setBusy(false); }
  };
  return (
    <Modal open title={`Cắt đầu / đuôi · ${target.label}`} onCancel={() => { if (!busy) onClose(); }} destroyOnClose maskClosable={!busy}
      footer={[
        <Button key="reset" disabled={busy || (target.cutInS == null && target.cutOutS == null)} onClick={() => { void save({ cutInS: null, cutOutS: null }); }} data-testid="wf-trim-reset">Bỏ cắt</Button>,
        <Button key="cancel" disabled={busy} onClick={onClose}>Huỷ</Button>,
        <Button key="ok" type="primary" loading={busy} disabled={!chk.ok || (chk.ok && chk.cutInS === null)} onClick={() => { if (chk.ok) void save(chk); }} data-testid="wf-trim-ok">Xác nhận cắt</Button>,
      ]}>
      <p className="muted" style={{ marginTop: 0 }}>
        Điểm cắt chỉ được ghi lại để dùng khi ghép ở CapCut — file clip gốc giữ nguyên và không tạo lại clip. Clip dài {dur ? `${dur} s` : '(chưa rõ)'}.
      </p>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <label>Cắt từ (giây){' '}<Input style={{ width: 96 }} inputMode="decimal" value={inS} disabled={busy} onChange={(e) => setInS(e.target.value)} data-testid="wf-trim-in" /></label>
        <label>đến (giây){' '}<Input style={{ width: 96 }} inputMode="decimal" value={outS} disabled={busy} onChange={(e) => setOutS(e.target.value)} data-testid="wf-trim-out" /></label>
      </div>
      <p style={{ margin: '10px 0 0' }} data-testid="wf-trim-summary">
        {chk.ok ? trimSummaryOf(dur, chk.cutInS, chk.cutOutS) : <span style={{ color: 'var(--bad-ink,#a32a17)' }}>{chk.message}</span>}
      </p>
      {err ? <Alert type="error" showIcon style={{ marginTop: 10 }} message={err} /> : null}
    </Modal>
  );
};

export default ClipTrimModal;
